import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Trophy.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...e, weights: m }));
r.displayName = "TrophyIcon";
const s = r;
export {
  s as Trophy,
  r as TrophyIcon
};
